define('sc_featuredcategory_button.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('sc_featuredcategory_button', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true}, 'extensions/Code 25/CaterpartsCategory/2.0.1/', 'extensions/Code 25/CaterpartsCategory/2.0.1/', Handlebars);
});